'use client';

import '@repo/design-system/styles/globals.css';

import { ApolloProvider } from '@apollo/client';
import { DesignSystemProvider } from '@repo/design-system';
import { fonts } from '@repo/design-system/lib/fonts';
import { client } from './lib/apollo';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html
      lang="en"
      className={`${fonts} overflow-hidden`}
      suppressHydrationWarning
    >
      <body>
        <ApolloProvider client={client}>
          <DesignSystemProvider defaultTheme="light">
            {children}
          </DesignSystemProvider>
        </ApolloProvider>
      </body>
    </html>
  );
}
